import React from 'react';
import { Modal, TextContainer } from '@superops/ui-design-system';

interface WarningDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  confirmLoading?: boolean;
  confirmDestructive?: boolean;
  confirmIcon?: React.ReactNode;
  variant?: 'default' | 'confirmation';
}

function WarningDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  confirmLoading = false,
  confirmDestructive = false,
  confirmIcon,
  variant = 'default'
}: WarningDialogProps) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={title}
      variant={variant}
      iconSize="xl"
      primaryAction={{
        content: confirmIcon ? (
          <span className="fx actr g5">
            {confirmIcon}
            <span>{confirmText}</span>
          </span>
        ) : (
          confirmText
        ),
        onAction: onConfirm,
        destructive: confirmDestructive,
        loading: confirmLoading
      }}
      secondaryActions={[
        {
          content: cancelText,
          onAction: onClose
        }
      ]}
    >
      {variant === 'confirmation' ? (
        <TextContainer>
          <p>{message}</p>
        </TextContainer>
      ) : (
        <Modal.Section>
          <TextContainer>
            <p>{message}</p>
          </TextContainer>
        </Modal.Section>
      )}
    </Modal>
  );
}

export default WarningDialog;
